/* eslint-disable react/self-closing-comp */
import React, { useEffect } from 'react';
import { Message, Header, Dropdown, Form, Table, Label } from 'semantic-ui-react';
import { useLazyQuery, useQuery } from '@apollo/client';
import { complaintByStatut, userByUserType } from '../graphql/queries';
import ComplaintDetail from '../components/admin/ComplaintDetail';
import DisplayLoading from '../components/common/DisplayLoading';
import DisplayError from '../components/common/DisplayError';
import { statusOptions } from '../services/complaint.data';

const AdminComplaintListPage = () => {
  const [retrieveComplaintByStatut, { loading, data, error }] = useLazyQuery(complaintByStatut);

  const {
    data: userList,
    error: userListError,
    loading: userListLoading
  } = useQuery(userByUserType, {
    variables: { userType: 'ADMIN' },
    fetchPolicy: 'network-only'
  });

  useEffect(() => {
    retrieveComplaintByStatut({
      variables: {
        statut: statusOptions[0].value
      }
    });
  }, [retrieveComplaintByStatut]);

  const handleChangeStatut = (e, { value }) => {
    retrieveComplaintByStatut({
      variables: {
        statut: value,
        fetchPolicy: 'network-only'
      }
    });
  };

  return (
    <>
      <DisplayLoading loadingMessage={loading && userListLoading} iconName="circle notched" />
      <DisplayError errorMessage={error} />
      <DisplayError errorMessage={userListError} />
      <Message>
        <Header as="h2" color="blue">
          Liste des plaintes
        </Header>
      </Message>
      <Form>
        {' '}
        <Table unstackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                <Label as="a" color="blue" horizontal>
                  Liste des plaintes par statut :
                </Label>
                <Dropdown
                  placeholder="Filtrer selon le statut"
                  openOnFocus
                  inline
                  selection
                  onChange={handleChangeStatut}
                  options={statusOptions}
                  // defaultValue={statusOptions[0].value}
                />
              </Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
        </Table>
      </Form>

      <ComplaintDetail data={data} userList={userList} />
    </>
  );
};

export default AdminComplaintListPage;
